import { Injectable } from '@angular/core';
import { AppService } from '../../../../../core/service/Base.Service';
import { List } from 'linqts';

@Injectable()
export class SystemPolicyService extends AppService<any> {

    constructor() {
        super('Policy');
    }

    async GetPolicy() {
        const result = await this.get('');
        return result;
    }

    async getsystemDaysPolicy(entityid, ttid) {

        const result = await this.get('SystemDays', [entityid, ttid]);
        return result;
    }

    async getsystemDaysNew(entityid, ttid, periodid) {
        let period = Number(periodid) === 0 ? "0" : Number(periodid);
        let timetable = !ttid || Number(ttid) === 0 ? "0" : Number(ttid);

        const result = await this.get('SystemDays', [entityid, timetable, period]);
        return result;
    }

    async getPolicy(entityid) {
        const result = await this.get('Policy', [entityid]);
        return result;
    }

}


// WEBPACK FOOTER //
// ./src/app/shell/forms/organizational-setup/setup/systempolicy/systempolicy.service.ts